var Firstlite = Firstlite || {};

Firstlite.ReviewFit = {

    state: {
        reviewsShown: 5,
    },

    constants: {

    },

    elements: {

      reviews: []
    },

    options: {

    },

    init : function(options, filterData) {
      var self = this;
      var reviews = $(".jdgm-rev-widg").data("number-of-reviews");
      var perPage = 10;
      var pages = Math.ceil(reviews / perPage);

      this.productId = $("#judgeme_product_reviews").data("id");

      this.pages = pages;
      //this.getReviews(1, perPage, this);

      //$(".jdgm-paginate").remove();
      this.scoreFits();

      // this.elements.$reviews = $(".jdgm-rev");
      // window.setTimeout(this.bindSort.bind(this), 1000);
      //
      // this.overwriteFunctions();
      // this.bindFilter();
      // this.bindShowMore();

      this.bindMutationObserver();

    },


    bindMutationObserver: function(){

      const config = { attributes: false, childList: true, subtree: false };
      const targetNode = $("#judgeme_product_reviews .jdgm-rev-widg__body")[0]
      const observer = new MutationObserver(this.scoreFits.bind(this));

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);

    },

    getReviews: function(page, perPage, context){
      var url = "https://judge.me/reviews/reviews_for_widget?url=" + Shopify.shop + "&shop_domain=" + Shopify.shop + "&platform=shopify&page=" + page + "&per_page=" + perPage + "&product_id=" + context.productId;

      $.ajax({
          url: url,
          success: function(data){
            $ajax = $(data.html);
            $ajax.find(".jdgm-rev").each(function(){
                var $review = $(this);
                var reviewId = $(this).data("review-id");
                var currentReview = $(".jdgm-rev-widg__reviews").find(".jdgm-rev[data-review-id=" + reviewId + "]").length;
                if(!currentReview){
                  $(".jdgm-rev-widg__reviews").append($review);
                }
            });

            $(".jdgm-rev__timestamp.jdgm-spinner").each(function(){
              var dateString = $(this).data("content");
              var date = new Date(dateString);
              $(this).removeClass("jdgm-spinner").text(date.toLocaleDateString("en-US"));
            });

            context.elements.$reviews = $(".jdgm-rev");
            window.setTimeout(context.bindSort.bind(context), 1000);

            var boundScoreFits = context.scoreFits.bind(context);
            boundScoreFits();
            context.resetShowMore();

            if(page < context.pages){
              context.getReviews(page + 1, perPage, context);
            }
          }
      });
    },

    mapScore: function(score){
      switch(score){
        case(1):
          return "Small";
        case(2):
          return "Bit Small";
        case(3):
          return "Perfect";
        case(4):
          return "Bit Large";
        case(5):
          return "Large";
      }
    },

    overwriteFunctions: function(){
      try{
        jdgm.filterReviewsByRating = function(){
          //do nothing
        }
      }catch(e){
        window.setTimeout(Firstlite.ReviewFit.overwriteFunctions, 1000);
      }
    },

    bindFilter : function(){
      var self = this;

      $(".jdgm-histogram__row").each(function(){
        $(this).off('click').on('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var rating = $(this).data("rating");
          self.filterStars(rating);
          $(".jdgm-histogram__row").removeClass("jdgm-histogram__row--selected");
          $(this).addClass("jdgm-histogram__row--selected");
        });
      });
    },

    filterStars : function(stars){
      $(".jdgm-rev").each(function(){
          if(stars){
            if(stars != $(this).find(".jdgm-rev__rating").data("score")){
              $(this).fadeOut().removeClass("filter-on").addClass("filter-off");
            }else{
              $(this).fadeIn().removeClass("filter-off").addClass("filter-on");
            }
            $(".jdgm-histogram__clear-filter").show();
          }else{
            $(".jdgm-histogram__clear-filter").hide();
            $(".jdgm-histogram__row").removeClass("jdgm-histogram__row--selected");
            $(this).fadeIn().removeClass("filter-off").addClass("filter-on");
          }
      });
      Firstlite.ReviewFit.resetShowMore();
    },

    bindShowMore: function(){
      $showButton = $("<button class='review-show-button review-show-button--show'>+ Show More</button>");
      $hideButton = $("<button class='review-show-button review-show-button--hide'>-</button>");
      $pagination = $("<div class='review-pagination'></div>").append($showButton).append($hideButton) ;
      $(".jdgm-rev-widg__body").append($pagination);
      $showButton.click(function(){
        Firstlite.ReviewFit.state.reviewsShown += 5;
        Firstlite.ReviewFit.resetShowMore();
      });
      $hideButton.click(function(){
        Firstlite.ReviewFit.state.reviewsShown -= 5;
        Firstlite.ReviewFit.resetShowMore();
      });

      Firstlite.ReviewFit.resetShowMore();
    },

    resetShowMore: function(){
      $(".jdgm-rev:not(.filter-off)").each(function(index){
        if(index < Firstlite.ReviewFit.state.reviewsShown){
          $(this).show();
        }else{
          $(this).hide();
        }
      });
      var reviews = $(".jdgm-rev:not(.filter-off)").length;
      var showOn = Firstlite.ReviewFit.state.reviewsShown <= reviews;

      if(showOn){
        $(".review-show-button--show").show();
      }else{
        $(".review-show-button--show").hide();
        Firstlite.ReviewFit.state.reviewsShown = Math.ceil(reviews / 5) * 5;
      }

      var hideOn = Firstlite.ReviewFit.state.reviewsShown > 5;
      if(hideOn){
        $(".review-show-button--hide").show();
      }else{
        $(".review-show-button--hide").hide();
      }
    },



    bindSort : function(){
      var self = this;
      $reviews = this.elements.$reviews;

      $(".jdgm-sort-dropdown option").each(function(){
        var value = $(this).attr("value");
        if(["most-recent", "highest-rating", "lowest-rating"].indexOf(value) == -1){
          $(this).remove();
        }
      });

      var $newSort = $(".jdgm-sort-dropdown").clone();
      $(".jdgm-sort-dropdown").after($newSort).remove();
      //default to highest rated
      $newSort.val("highest-rating");

      $(document).on("change", ".jdgm-sort-dropdown", function(e){
        e.preventDefault();
        e.stopPropagation();
        var val = $(this).val();
        var sortFunction = self.sortRating("dec");
        switch(val){
          case "most-recent":
            sortFunction = self.sortDate("dec");
            break;
          case "highest-rating":
            sortFunction = self.sortRating("dec");
            break;
          case "lowest-rating":
            sortFunction = self.sortRating("asc");
            break;
          case "with-pictures":
            break;
          case "pictures-first":
            break;
          case "videos-first":
            break;
          case "most-helpful":
            break;
        }

        $reviews.sort(sortFunction);
        $(".jdgm-rev-widg__reviews").html($reviews);
        Firstlite.ReviewFit.resetShowMore();
      });
    },


    sortDate: function(direction){
      return function(a,b){
        aInt = new Date($(a).find(".jdgm-rev__timestamp").data("content")).getTime();
        bInt = new Date($(b).find(".jdgm-rev__timestamp").data("content")).getTime();
        if(direction == "asc"){
          return aInt - bInt;
        }else{
          return bInt - aInt;
        }
      }
    },

    sortRating: function(direction){
      return function(a,b){
        if(direction == "asc"){
          return $(a).find(".jdgm-rev__rating").data("score") - $(b).find(".jdgm-rev__rating").data("score")
        }else{
          return $(b).find(".jdgm-rev__rating").data("score") - $(a).find(".jdgm-rev__rating").data("score")
        }
      }
    },

    scoreFits : function(){
      var self = this;
      this.fitscores = [];

      if($(".jdgm-rev__cf-ans__title").length == 0){
        return;
      }

      $(".jdgm-rev__cf-ans__title").each(function(){
          if($(this).text().toLowerCase().indexOf("fit:") > -1){
            var $answer = $(this).next();
            var content = parseInt($answer.text());
            var data = parseInt($answer.data("score"));
            if(!isNaN(content)){ // content is the score
              self.fitscores.push(content);
              $answer.data("score", content);
              $answer.text(self.mapScore(content));
            }else if(!isNaN(data)){ // score is attached to answer in a data attribute
              self.fitscores.push(data);
            }else if($answer.hasClass("jdgm-cf-bars-wrapper")){ // score is represented in bars
              var score = $answer.find(".jdgm--filled").length;
              self.fitscores.push(score);
              $answer.data("score", score).text(self.mapScore(score)).removeClass("jdgm-cf-bars-wrapper").addClass("jdgm-rev__cf-ans__value");
            }
          }
      });

      this.fitScoreCount = this.fitscores.length
      this.fitSum = 0;

      for( var i = 0; i < this.fitScoreCount; i++ ){
          this.fitSum += parseInt( this.fitscores[i], 10 ); //don't forget to add the base
      }

      this.fitAvg = this.fitSum/this.fitScoreCount;

      this.renderWidgetFitSummary();
      this.renderProductFitSummary();
    },

    renderWidgetFitSummary: function(){
      $("#rating-widget-fit-summary").remove();
      $widgetFitSummary = $('<div id="rating-widget-fit-summary" class="rating-box Fit"><div class="rating-title">Fit Feedback<em>Based on Reviews</em></div><div class="rating" style="width:' + this.fitAvg * 20 + '%;"></div><div class="rating-tic left"></div><div class="rating-tic center"></div><div class="rating-tic right"></div><div class="rating-label left">Runs Small</div><div class="rating-label center">Perfect</div><div class="rating-label right">Runs Large</div></div>');
      $(".jdgm-histogram").after($widgetFitSummary)
    },

    renderProductFitSummary: function(){
      $("#rating-product-fit-summary").remove();
      $productFitSummary = $('<div id="rating-product-fit-summary" class="rating-box Fit"><div class="rating-title">Fit Feedback<em>Based on Reviews</em></div><div class="rating" style="width:' + this.fitAvg * 20 + '%;"></div><div class="rating-tic left"></div><div class="rating-tic center"></div><div class="rating-tic right"></div><div class="rating-label left">Runs Small</div><div class="rating-label center">Perfect</div><div class="rating-label right">Runs Large</div></div>');
      $(".fit-container").append($productFitSummary)
    }

}
